// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.sandbox_session.DirectoryEntry

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { FileEntryData } from "./FileEntry.generated";

export interface DirectoryEntryData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DirectoryEntry";
    entries: FileEntryData[];
    watch_revision: number;
}

export class DirectoryEntryStore {
    readonly _entity_class_name = "DirectoryEntry" as const;
    entries: FileEntryData[];
    watch_revision: number;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DirectoryEntryData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.entries = wrapEntity(data.entries, transport, [...chainPath, "entries"]);
        this.watch_revision = wrapEntity(data.watch_revision, transport, [...chainPath, "watch_revision"]);
        makeObservable(this, {
            entries: observable,
            watch_revision: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("DirectoryEntry", DirectoryEntryStore);
